import { getCookie } from 'utils/cookies';

const USER_COOKIE_KEY = 'parr-user';

type CurrentUserUuid = { uuid: string };

export const getCurrentUserUuid = (): string => {
  const user = getCookie<CurrentUserUuid>(USER_COOKIE_KEY);
  return user?.uuid ?? '';
};
